"use client";

import { useEffect, useState } from "react";

import { PostCard } from "@/components/marketplace/Cards";
import { isUsableWebSession, useAuthStore } from "@/lib/auth-store";
import { feedApi } from "@/lib/client-api";
import type { SocialPost } from "@/lib/types";
import { useMounted } from "@/lib/use-mounted";

export function HomeSocialFeed({ initialPosts }: { initialPosts: SocialPost[] }) {
  const mounted = useMounted();
  const user = useAuthStore((state) => state.user);
  const accessToken = useAuthStore((state) => state.accessToken);
  const demoMode = useAuthStore((state) => state.demoMode);
  const [posts, setPosts] = useState(initialPosts);

  useEffect(() => {
    if (!mounted || !isUsableWebSession({ user, accessToken, demoMode }) || demoMode) {
      return;
    }

    let active = true;
    void feedApi
      .forYou(12)
      .then((personalized) => {
        if (active) setPosts(personalized);
      })
      .catch(() => {
        // Keep the public SSR feed when personalized delivery is unavailable.
      });
    return () => {
      active = false;
    };
  }, [accessToken, demoMode, mounted, user]);

  if (!posts.length) {
    return (
      <div className="empty-panel">
        No public feed posts are available yet. New farmer, buyer, and provider posts will appear here as soon as they are published.
      </div>
    );
  }

  return (
    <div className="grid-3">
      {posts.slice(0, 3).map((post) => (
        <PostCard key={post.id} post={post} />
      ))}
    </div>
  );
}
